export default "__VITE_ASSET__BWgTzzxR__"